/*global require, define, $*/
define('core/directives/dnaCalloutDirective',[
    'angular'
], function(angular) {
    'use strict';
    /*
        CALLOUT MARKUP:
        <span data-dna-callout="#calloutContentSelector">
            <!-- This is the callout -->
            <div class="calloutModifiersGoHere" data-callout-classes="calloutClassesGoHere"></div>
        </span>
        OR
        <span data-dna-callout>
            <!-- This is the callout -->
            <div class="calloutModifiersGoHere" data-callout-classes="calloutClassesGoHere"></div>
            <!-- If the data-dna-callout attr has no value, the callout content should be next to the callout trigger -->
            <p>This is the callout content.</p>
        </span>
     */
    angular.module('dnaApp').directive('dnaCallout', ['$timeout', function($timeout) {
            return {
                scope: {
                    dnaCallout: '@',
                    content: '@',
                    style: '@',
                    classes: '@',
                    calloutClasses: '@',
                    dnaCalloutWait: '@',
                    onOpen: '&',
                    onClose: '&',
                    onAfterOpen: '&',
                    dnaAutoClose: '@'
                },
                restrict: 'AE',
                template: '<ng-transclude></ng-transclude>',
                transclude: true,
                link: function(scope, element) {
                    var autoCloseCallback, autoCloseDelay = 1500;

                    function closeCurrentCallout() {
                        $('.calloutTrigger.active').callout('close');
                    };

                    if (!scope.dnaCalloutWait) {
                        scope.dnaCalloutWait = 100;
                    }

                    autoCloseCallback = function () {
                        scope.onAfterOpen();
                        $timeout(closeCurrentCallout, autoCloseDelay);
                    };

                    /* Looks for content selector inside the data-dna-callout attribute; if data-dna-callout is empty, content should be 2nd child of element. */
                    var $mainElem = element.children().first(),
                        $calloutTrigger = $mainElem.children().first(),
                        $calloutContent = scope.dnaCallout || scope.content || $calloutTrigger.next();
                    /* To modify callout settings, add class modifiers to the HTML markup (see http://ancestrystage.com/cs/standards/callouts#class-modifiers) */
                    $calloutTrigger.callout({
                        content: $calloutContent,
                        style: scope.style,
                        classes: scope.classes,
                        calloutClasses: scope.calloutClasses,
                        showDelay: scope.dnaCalloutWait,
                        onOpen: scope.onOpen,
                        onClose: scope.onClose,
                        onAfterOpen: scope.dnaAutoClose ? autoCloseCallback : scope.onAfterOpen
                    });
                    scope.$on('$destroy', function() {
                        $calloutTrigger.callout('destroy');
                    });
                }
            };
        }]);
});

